import { render, staticRenderFns } from "./AssistantService.vue?vue&type=template&id=6c1b9708&scoped=true"
import script from "./AssistantService.vue?vue&type=script&lang=js"
export * from "./AssistantService.vue?vue&type=script&lang=js"
import style0 from "./AssistantService.vue?vue&type=style&index=0&id=6c1b9708&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1b9708",
  null
  
)

export default component.exports